"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountEnrollmentToJSON = exports.AccountEnrollmentFromJSONTyped = exports.AccountEnrollmentFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function AccountEnrollmentFromJSON(json) {
    return AccountEnrollmentFromJSONTyped(json, false);
}
exports.AccountEnrollmentFromJSON = AccountEnrollmentFromJSON;
function AccountEnrollmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': _1.AccountTypeFromJSON(json['type']),
        'companyInfo': _1.CompanyInfoFromJSON(json['companyInfo']),
        'webServiceAccess': _1.WebServiceAccessFromJSON(json['webServiceAccess']),
        'marketingChannel': !runtime_1.exists(json, 'marketingChannel') ? undefined : _1.EnrollmentChannelFromJSON(json['marketingChannel']),
        'hiringSites': !runtime_1.exists(json, 'hiringSites') ? undefined : (json['hiringSites'].map(_1.HiringSiteFromJSON)),
        'contacts': !runtime_1.exists(json, 'contacts') ? undefined : (json['contacts'].map(_1.EnrollmentContactFromJSON)),
        'parentId': !runtime_1.exists(json, 'parentId') ? undefined : json['parentId'],
    };
}
exports.AccountEnrollmentFromJSONTyped = AccountEnrollmentFromJSONTyped;
function AccountEnrollmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': _1.AccountTypeToJSON(value.type),
        'companyInfo': _1.CompanyInfoToJSON(value.companyInfo),
        'webServiceAccess': _1.WebServiceAccessToJSON(value.webServiceAccess),
        'marketingChannel': _1.EnrollmentChannelToJSON(value.marketingChannel),
        'hiringSites': value.hiringSites === undefined ? undefined : (value.hiringSites.map(_1.HiringSiteToJSON)),
        'contacts': value.contacts === undefined ? undefined : (value.contacts.map(_1.EnrollmentContactToJSON)),
        'parentId': value.parentId,
    };
}
exports.AccountEnrollmentToJSON = AccountEnrollmentToJSON;
